import React from 'react'
import {  Box } from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';

// const firstRow = {
//     id: 1,
//     Task_Catagery:"",
//     Task_Descrption: "",
//     Sch_Hr: "",
//     Act_Hr: "",
//     Rate_Hr: "",
//     Taxable_Amount: "",
//     Vat: "",
//     Vat_Amt: "",
//     Total_Amount: "",
//     Staff: "",
//     Bay: "",
//     Task_Status: "",
    
// }

// const boxStyle = {
//     root: {
//       backgroundColor: 'white', 
//       borderRadius: '5px',
//       padding: 1
//     },
//   };


function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />  
  );}

function WorkverificationTask() {
    const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false },
    { field: 'Task_Catagery', headerName: 'Task Catagery', editable: false, sortable: false, flex: 1.5, minWidth: 100 },
    { field: 'Task_Descrption', headerName: 'Task_Descrption', editable: false, sortable: false, flex: 1.5, minWidth: 100 },
    { field: 'Sch_Hr', headerName: 'Sch Hr', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Act_Hr', headerName: 'Act Hr', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Rate_Hr', headerName: 'Rate/Hr', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Taxable_Amount', headerName: 'Taxable Amount', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Vat', headerName: 'Vat%', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Vat_Amt', headerName: 'Vat Amt', editable: false, sortable: false ,flex: 1, minWidth: 100},
    { field: 'Total_Amount', headerName: 'Total Amount', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Staff', headerName: 'Staff', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Bay', headerName: 'Bay', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Task_Status', headerName: 'Task Status', editable: false, sortable: false, flex: 1, minWidth: 100 },
    ]; 
    
    const rows = [
    { id: '1', Task_Catagery:'', Task_Descrption:'', Sch_Hr:'', Act_Hr:'', Rate_Hr:'', Taxable_Amount:'', Vat:'', Vat_Amt:'', Total_Amount:'', Staff:'', Bay:'', Task_Status:''},
    { id: '2', Task_Catagery:'', Task_Descrption:'', Sch_Hr:'', Act_Hr:'', Rate_Hr:'', Taxable_Amount:'', Vat:'', Vat_Amt:'', Total_Amount:'', Staff:'', Bay:'', Task_Status:''},
    { id: '3', Task_Catagery:'', Task_Descrption:'', Sch_Hr:'', Act_Hr:'', Rate_Hr:'', Taxable_Amount:'', Vat:'', Vat_Amt:'', Total_Amount:'', Staff:'', Bay:'', Task_Status:''},
    { id: '4', Task_Catagery:'', Task_Descrption:'', Sch_Hr:'', Act_Hr:'', Rate_Hr:'', Taxable_Amount:'', Vat:'', Vat_Amt:'', Total_Amount:'', Staff:'', Bay:'', Task_Status:''},
    { id: '5', Task_Catagery:'', Task_Descrption:'', Sch_Hr:'', Act_Hr:'', Rate_Hr:'', Taxable_Amount:'', Vat:'', Vat_Amt:'', Total_Amount:'', Staff:'', Bay:'', Task_Status:''},
    
    
    ];                              
    return (
      <form>
        <Box mt={1}>
          <DataGrid
            columnHeaderHeight={30}
            rowHeight={30}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            pageSizeOptions={[10]}
            slots={{ columnMenu: CustomColumnMenu }}
            disableRowSelectionOnClick
          />
        </Box>
      </form>
    );
}

export default WorkverificationTask